import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 text-right mb-3" }, null, -1)
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "media-list media-list-linked media-list-bordered" }
const _hoisted_5 = { class: "media bg-light font-weight-semibold py-2" }
const _hoisted_6 = { class: "media-body" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "mr-3" }
const _hoisted_9 = {
  href: "#",
  class: "btn bg-transparent border-blue text-blue rounded-pill border-2 btn-icon"
}
const _hoisted_10 = { class: "media-body d-flex flex-row align-items-center" }
const _hoisted_11 = { class: "d-flex flex-column" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Mo - So | ")
const _hoisted_13 = { class: "text-muted" }
const _hoisted_14 = { class: "d-flex flex-row mt-2" }
const _hoisted_15 = {
  key: 0,
  class: "ml-3"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "icon-trash" }, null, -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "ml-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "list-icons" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "list-icons-item"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow-right15" })
    ])
  ])
], -1)
const _hoisted_20 = { class: "bg-body" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/_createStaticVNode("<div class=\"mr-3\"><a href=\"#\" class=\"text-accent\"><i class=\"icon-plus2\"></i></a></div><div class=\"media-body d-flex flex-row align-items-center\"><div class=\"text-accent\"> Neue Intervention anlegen </div></div><div class=\"ml-3\"><div class=\"list-icons text-accent\"><a href=\"#\" class=\"list-icons-item\"><i class=\"icon-arrow-right15\"></i></a></div></div>", 3)
const _hoisted_25 = [
  _hoisted_22
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.interventions, (intervention, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            _createElementVNode("li", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.interventionTypes[index]?.name), 1)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(intervention.items, (item, subIndex) => {
              return (_openBlock(), _createElementBlock("li", { key: subIndex }, [
                _createElementVNode("a", {
                  class: "media cursor-pointer align-items-center",
                  onClick: ($event: any) => (_ctx.editIntervention(item.id))
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("a", _hoisted_9, [
                      _createElementVNode("i", {
                        class: _normalizeClass(_ctx.interventionTypes[item.interventionType]?.icon)
                      }, null, 2)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", null, [
                        _hoisted_12,
                        _createElementVNode("small", _hoisted_13, _toDisplayString(_ctx.timeRanges[item.timeRange].name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.contactOrder, (unit, uIndex) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: uIndex,
                            class: "badge bg-accent mr-1"
                          }, _toDisplayString(_ctx.interventionTypes[item.interventionType]?.[unit]?.name), 1))
                        }), 128))
                      ])
                    ])
                  ]),
                  (_ctx.shouldDisableInterventionChanges())
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-danger-100 text-danger btn-icon ml-2",
                          onClick: _withModifiers(($event: any) => (_ctx.deleteIntervention(item)), ["stop"])
                        }, _hoisted_18, 8, _hoisted_16)
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_19
                ], 8, _hoisted_7)
              ]))
            }), 128)),
            _createElementVNode("li", _hoisted_20, [
              _createElementVNode("a", {
                class: "media cursor-pointer align-items-center",
                onClick: ($event: any) => (_ctx.newIntervention(index))
              }, _hoisted_25, 8, _hoisted_21)
            ])
          ], 64))
        }), 128))
      ])
    ])
  ]))
}